import React, { useCallback, useState, useEffect, useContext } from 'react'
import { getCompanyUsers, getSignerAssignments } from '../../../services/apiHelper'
import CompanyAssignment from './CompanyAssignment'
import DetailView from '../../../dpe-usco/components/Details/DetailView'
import UserInformation from './UserInformation'
import UpdateUserForm from './UpdateUserForm'
import { GlobalContext } from '../../../services/context'
import { useParams } from 'react-router-dom'

const UserDetailView = () => {
  const [userInfo, setUserInfo] = useState(null)
  const [showModal, setShowModal] = useState(false)
  const { dispatch } = useContext(GlobalContext)
  let [assignmentData, setAssignmentData] = useState([])
  let [status, setStatus] = useState('EMPTY')
  const { user_id } = useParams() || {}

  useEffect(() => {
    setStatus('LOADING')
    getSignerAssignments(user_id).then(response => {
      if (response && response.length) {
        const updatedResponse = response.map(obj => {
          return {
            ...obj,
            location: `${obj.city}, ${obj.state} `
          }
        })
        if (updatedResponse.length) {
          setAssignmentData(updatedResponse)
          setStatus(null)
        } else {
          setStatus('EMPTY')
        }
      }
    })
  }, [user_id])

  const getUser = useCallback(() => {
    getCompanyUsers('user_id', user_id)?.then(res => {
      if (res) {
        const fname = res.first || 'N/A'
        const lname = res.last || 'N/A'
        const payload = {
          id: res.user_id,
          title: `${fname} ${lname}`,
          previous: 'Back'
        }
        dispatch({ type: 'UPDATE_DETAIL_VIEW_SAVE_LAST_VIEW', payload })
      }
      setUserInfo(res)
    })
  }, [dispatch, user_id])

  useEffect(() => {
    getUser()
  }, [getUser])

  return (
    <DetailView>
      <>
        <CompanyAssignment status={status} assignmentData={assignmentData}></CompanyAssignment>
        {userInfo && <UpdateUserForm showModal={showModal} setShowModal={setShowModal} userInfo={userInfo} getUser={getUser}/>}
      </>
      <>
        {userInfo && <UserInformation userInfo={userInfo} handleModal={() => setShowModal(true)}/>}
      </>
    </DetailView>
  )
}

export default UserDetailView